import axios from "./api";
const paymentBaseUrl = "/admin/payment";

const PaymentDetails = {
  getCustomerById(id) {
    return axios.get(`${paymentBaseUrl}/customer?customer_id=` + id);
  },
};

export default PaymentDetails;
